import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { ErrorSnackbarComponent, ErrorSnackbarData } from '@platform/components/error-snackbar/error-snackbar.component';
import { ProblemDetails } from '@platform/shared/http/problem-details';

@Injectable({
  providedIn: 'root',
})
export class ToastService {
  constructor(
    private snackBar: MatSnackBar,
    private translate: TranslateService,
  ) {}

  public showPendingToast(translationKey: string, interpolateParams?: object) {
    this.snackBar.open(this.translate.instant(translationKey, interpolateParams), '', {
      duration: 2000,
      panelClass: ['snackbar-width', 'mat-snackbar-pending'],
      verticalPosition: 'top',
    });
  }

  public showSuccessToast(translationKey: string, interpolateParams?: object) {
    this.snackBar.open(this.translate.instant(translationKey, interpolateParams), '', {
      duration: 2000,
      panelClass: ['snackbar-width', 'mat-snackbar-success'],
      verticalPosition: 'top',
    });
  }

  public showErrorToast(translationKey: string, interpolateParams?: object) {
    this.snackBar.open(this.translate.instant(translationKey, interpolateParams), this.translate.instant('toast.error-action'), {
      panelClass: ['snackbar-width', 'mat-snackbar-error'],
      verticalPosition: 'top',
    });
  }

  public showErrorToastDetail(translationKey: string, interpolateParams?: object, detail?: ProblemDetails) {
    this.snackBar.open(this.translate.instant(translationKey, interpolateParams), this.translate.instant('toast.error-action'), {
      panelClass: ['snackbar-width', 'mat-snackbar-error'],
      verticalPosition: 'top',
      data: detail,
    });
  }

  public showErrorToastDetailFromComponent(translationKey: string, interpolateParams?: object, detail?: ProblemDetails) {
    this.snackBar.openFromComponent(ErrorSnackbarComponent, {
      data: {
        messageT: translationKey,
        messageTParams: interpolateParams,
        problemDetail: detail,
      } as ErrorSnackbarData,
      verticalPosition: 'top',
      panelClass: ['snackbar-width', 'mat-snackbar-error-detail'],
    });
  }
}
